module.exports = __webpack_public_path__ + "static/blue-841175d7fa1b3c0e66da161a144a2093.jpg";